// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-IdBox-IdBox-module__idBox--IJcr8 {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 8px;
  width: 100%;
}
/*# sourceMappingURL=IdBox.module.css.map */`, "",{"version":3,"sources":["webpack://./IdBox.module.less","webpack://./src/components/IdBox/IdBox.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,WAAA;ACCF;AACA,2CAA2C","sourcesContent":[".idBox {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 8px;\n  width: 100%;\n}\n",".idBox {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 8px;\n  width: 100%;\n}\n/*# sourceMappingURL=IdBox.module.css.map */"],"sourceRoot":""}]);
// Exports
export var idBox = `src-components-IdBox-IdBox-module__idBox--IJcr8`;
export default ___CSS_LOADER_EXPORT___;
